import Repository from "./Repository";
const getGolfClub = "api/boardbyslug/";

export default {
    getGolfClub(board) {
        return Repository.get(`${getGolfClub}${board}`);
    },
};
